(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('passengerTypesCtrl', passengerTypesCtrl)
        .controller('passengerTypeNewEditCtrl', passengerTypeNewEditCtrl)
        .controller('modalPassengerTypeDisableCtrl', modalPassengerTypeDisableCtrl)
        .controller('modalAddAgeRangeCtrl', modalAddAgeRangeCtrl);

    passengerTypesCtrl.$inject = ['passengerTypes', 'linkService'];
    passengerTypeNewEditCtrl.$inject = ['linkService', 'passengerType', 'edit', 'passengerTypeService','$uibModal'];
    modalPassengerTypeDisableCtrl.$inject = ['$uibModalInstance', '$stateParams', 'passengerTypeService','passengerType'];
    modalAddAgeRangeCtrl.$inject = ['operators', 'ageRangesSelected','$uibModalInstance'];

    function passengerTypesCtrl(passengerTypes, linkService) {
        var vm = this;
        vm.linkService = linkService;
        vm.passengerTypes = passengerTypes.data._embedded ? passengerTypes.data._embedded.passengerTypes : [];
    }

    function passengerTypeNewEditCtrl(linkService, passengerType, edit,passengerTypeService,$uibModal) {
        var vm = this;
        vm.linkService = linkService;
        vm.edit = edit;
        vm.passengerType = {};
        vm.passengerTypesDisabled = [];
        vm.group = [
            {
                "name":"adult",
                "nameLang":"air.passengerType.group.adult"
            },
            {
                "name":"child",
                "nameLang":"air.passengerType.group.child"
            },
            {
                "name":"infant",
                "nameLang":"air.passengerType.group.infant"
            }
        ];

        if(edit){
            vm.passengerType = passengerType.data;
            vm.passengerTypeDisable = angular.copy(vm.passengerType);
        }

        vm.getPassengerTypesDisabled = function(group){
            if(group != undefined) {
                passengerTypeService.getPassengerTypesDisabled(group)
                    .then(function (response) {
                        vm.passengerTypesDisabled = (response.data._embedded) ? response.data._embedded.passengerTypes : [];
                    });
            }else{
                vm.passengerTypesDisabled = [];
                vm.passengerType = {};
            }
        }

        vm.getPassengerTypes = function(){
            passengerTypeService.getPassengerTypes()
                .then(function (response) {
                    vm.passengerTypesDisabled = response.data._embedded.passengerTypes;
                });
        }

        if(edit){
            vm.getPassengerTypes();
        }

        vm.setPassengerType = function(passengerType){
            if(passengerType != undefined){
                vm.passengerType = angular.copy(passengerType);
            }else{
                vm.passengerType.code = "";
            }
        }

        vm.savePassengerType = function (isValid, passengerType) {
            if (isValid) {
                var savePassengerType = {
                    "information": passengerType.information,
                    "ageRanges": []
                }
                if(passengerType._embedded != undefined){
                    angular.forEach(passengerType._embedded.ageRanges, function (ageRange) {
                        var saveAgeRange = {
                            "age": ageRange.age,
                            "code": ageRange._embedded.operator.code
                        }
                        savePassengerType.ageRanges.push(saveAgeRange);
                    });
                }

                passengerTypeService.updatePassengerType(savePassengerType,
                    vm.linkService.getLinkId(passengerType._links.self.href));
            }
        };

        vm.deleteAgeRange = function(index){
            vm.passengerType._embedded.ageRanges.splice(index, 1);
        }

        vm.cancel = function () {
            linkService.reloadRoute('passengerTypes', null);
        };

        vm.addAgeRange = function(ageRanges){
            $uibModal.open({
                templateUrl: 'app/admin/configGeneral/passengerType/modalAddAgeRange.html',
                controller: 'modalAddAgeRangeCtrl',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['ageRange']);
                    }],
                    operators: ['operatorService', function(operatorService) {
                        return operatorService.getOperators();
                    }],
                    ageRangesSelected: [function() {
                        return ageRanges;
                    }]
                }
            }).result.then(function(response) {
                if(vm.passengerType._embedded == undefined){
                    vm.passengerType._embedded = {
                       'ageRanges': []
                    };
                    vm.passengerType._embedded.ageRanges.push(response);
                }else{
                    vm.passengerType._embedded.ageRanges.push(response);
                }
            }, function() {
                //$state.go('^');
            });
        }
    }

    function modalPassengerTypeDisableCtrl($uibModalInstance, $stateParams, passengerTypeService,passengerType) {
        var vm = this;
        vm.name = passengerType.data.lang;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.disablePassengerTypeConfirm = function () {
            passengerTypeService.disablePassengerType($stateParams.id)
                .then(function () {
                    $uibModalInstance.close(true);
                });
        }
    }

    function modalAddAgeRangeCtrl(operators, ageRangesSelected,$uibModalInstance){
        var vm = this;
        vm.operators = [];
        vm.ageRangesSelected = ageRangesSelected;

        vm.getOperators = function(operators){
            var resOperators = [];
            if(ageRangesSelected != undefined){
                angular.forEach(ageRangesSelected, function(ageRange){
                    angular.forEach(operators, function(operator){
                        if(ageRange._embedded.operator.code.indexOf(operator.code.substr(0,1)) < 0){
                            resOperators.push(operator)
                        }
                    })
                })
            }else{
                resOperators = operators;
            }
            return resOperators;
        }

        vm.operators = vm.getOperators(operators);

        vm.addAgeRange = function(isValid,ageRange){
            if(isValid){
                $uibModalInstance.close(ageRange);
            }
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
